export default __webpack_public_path__ + "static/media/Gr_Price.c36fd31e.svg";